const captchaImageId = 'captcha-image';
const failedAttemptsStorageKey = 'mx.auth.failedAttempts';

export function urlParam(name: string): string {
	name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	const results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function createCaptchaCode(): string {
	const charsArray = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*';
	const lengthOtp = 6;
	const captcha: string[] = [];
	for (let i = 0; i < lengthOtp; i++) {
		//below code will not allow Repetition of Characters
		const index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
		if (!captcha.includes(charsArray[index])) {
			captcha.push(charsArray[index]);
		} else {
			i--;
		}
	}
	return captcha.join('');
}

function createCaptchaImage(code: string): HTMLImageElement {
	const canv = document.createElement('canvas');
	canv.width = 130;
	canv.height = 50;
	const ctx = canv.getContext('2d') as CanvasRenderingContext2D;
	ctx.font = '25px Georgia';
	ctx.strokeText(code, 0, 30);

	const image = new Image();
	image.id = captchaImageId;
	image.src = canv.toDataURL();

	return image;
}

export function renderCaptcha(): string {
	const code = createCaptchaCode();
	const image = createCaptchaImage(code);

	const previousImage = document.getElementById(captchaImageId);
	previousImage?.remove();

	const captchaContainer = document.getElementById('captcha-box');
	captchaContainer?.insertBefore(image, captchaContainer.firstChild);
	return code;
}

export function validateCaptcha(code: string): boolean {
	const captchaCodeEl = document.getElementById('captcha-code') as HTMLInputElement;
	return captchaCodeEl?.value === code;
}

export function isCaptchaActivated(): boolean {
	let failedAttempts = parseInt(localStorage.getItem(failedAttemptsStorageKey) || '', 10) || 0;
	const errorFromParams = urlParam('error') || null;
	if (errorFromParams) {
		failedAttempts++;
		localStorage.setItem(failedAttemptsStorageKey, failedAttempts.toString());
	}

	return failedAttempts >= 3;
}

export function clearFailedAttempts(): void {
	localStorage.removeItem(failedAttemptsStorageKey);
}
